import axios from 'axios';
import cookie from 'js-cookie';

import { listApi, detailsApi, createApi, updateApi, deleteApi, searchApi } from './index';

const exerciseSubdomain = 'exercises';
let axiosConfig = {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    "authorization": "Token " + cookie.get('token')
  }
};

export function fetchExercisesMoreList(limit, offset) {
  const url = `${process.env.REACT_APP_SERVER_URL
    }/${exerciseSubdomain}/?limit=${limit}&offset=${offset}`;
  return axios.get(url, axiosConfig).then(res => res.data);
}

export function fetchSearchExercisesMoreList(limit, offset, search) {
  const url = `${process.env.REACT_APP_SERVER_URL
    }/${exerciseSubdomain}/?limit=${limit}&offset=${offset}&search=${search}`;
  return axios.get(url, axiosConfig).then(res => res.data);
}

export function fetchSearchExercises(query) {
  const url = `${process.env.REACT_APP_SERVER_URL
    }/${exerciseSubdomain}/${query}`;
  return axios.get(url, axiosConfig).then(res => res.data);
}

export const fetchExerciseDetails = id => detailsApi({ subdomain: exerciseSubdomain, id });

export const fetchExercises = () => listApi({ subdomain: exerciseSubdomain });

export const searchExercises = ({ search }) => searchApi({ subdomain: exerciseSubdomain, search });

export const addNewExercise = payload => createApi({ subdomain: exerciseSubdomain, payload });

export const deleteExercise = id => deleteApi({ subdomain: exerciseSubdomain, id });

export const updateExerciseDetails = payload =>
  updateApi({ subdomain: exerciseSubdomain, payload });